module.exports = __webpack_public_path__ + "images/emoji/first_quarter_moon.9e0fa8fdba7be4e1df62.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/first_quarter_moon.png
// module id = 508S
// module chunks = 1